import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TID } from "@/lib/testIds";
import { Card } from "@/components/ui/card";
import { Car, ArrowSquareIn, ArrowSquareOut, IdentificationCard } from "@phosphor-icons/react";

function Stat({ label, v, Icon, tid }) {
  return (
    <Card className="bg-[#141414] border-zinc-800 p-6">
      <div className="flex items-center justify-between">
        <p className="text-[10px] font-mono uppercase tracking-[0.2em] text-zinc-500">{label}</p>
        <Icon size={18} className="text-zinc-500" />
      </div>
      <p className="mt-3 font-mono text-3xl" data-testid={TID.metric(tid)}>{v}</p>
    </Card>
  );
}

export default function Operations() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/dashboard/operations").then(r => setData(r.data)); }, []);
  if (!data) return <div className="text-zinc-500">Loading…</div>;
  return (
    <div className="space-y-8">
      <header>
        <p className="text-xs font-mono uppercase tracking-[0.3em] text-zinc-500">Operations</p>
        <h1 className="font-heading text-4xl font-black tracking-tighter mt-1">Live floor activity.</h1>
      </header>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat label="Active Sessions" v={data.active_sessions} Icon={Car} tid="active-sessions" />
        <Stat label="Entries Today" v={data.entries_today} Icon={ArrowSquareIn} tid="entries-today" />
        <Stat label="Exits Today" v={data.exits_today} Icon={ArrowSquareOut} tid="exits-today" />
        <Stat label="Visitors Today" v={data.visitors_today} Icon={IdentificationCard} tid="visitors-today" />
      </div>
      <Card className="bg-[#141414] border-zinc-800 p-6">
        <p className="text-xs font-mono uppercase tracking-[0.2em] text-zinc-500">Vehicles Inside</p>
        <div className="mt-4 overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-zinc-500 text-xs font-mono uppercase">
                <th className="py-2 pr-4">Plate</th><th className="py-2 pr-4">Type</th>
                <th className="py-2 pr-4">Slot</th><th className="py-2 pr-4">Entry</th>
                <th className="py-2 pr-4">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-800">
              {data.vehicles_inside.map(s => (
                <tr key={s.id}>
                  <td className="py-2 pr-4 font-mono">{s.plate_number}</td>
                  <td className="py-2 pr-4 capitalize">{s.session_type}</td>
                  <td className="py-2 pr-4 font-mono">{s.slot_id ? s.slot_id.slice(0,8) : "—"}</td>
                  <td className="py-2 pr-4 text-zinc-400">{new Date(s.entry_time).toLocaleString()}</td>
                  <td className="py-2 pr-4">
                    <span className="inline-block px-2 py-0.5 text-xs rounded bg-emerald-500/15 text-emerald-300 border border-emerald-500/30">
                      {s.status}
                    </span>
                  </td>
                </tr>
              ))}
              {data.vehicles_inside.length === 0 && (
                <tr><td colSpan={5} className="py-6 text-center text-zinc-500">No vehicles currently inside.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
